import { userRequest, BASE_URL } from "../requestMethods";
import { toast } from "react-toastify";

import {
  addProducttoCartStart,
  addProducttoCartSuccess,
  addProducttoCartFailure,
  removeProducttoCartStart,
  removeProducttoCartSuccess,
  removeProducttoCartFailure,
  getCartStart,
  getCartSuccess,
  getCartFailure,
  clearCart
} from "../redux/cartRedux";

export const addToCart = async (dispatch, userId, obj) => {
  console.log(obj, "dispatch");

  dispatch(addProducttoCartStart());
  try {
    const res = await userRequest.post(`${BASE_URL}cart/addToCart/?userId=${userId}`, obj);
    console.log(res.data, "add cart details");
    toast.success(`🦄 ${res.data.message}`);
    dispatch(addProducttoCartSuccess(res.data));
    getCartData(dispatch, userId, "runn 2");
  } catch (err) {
    dispatch(addProducttoCartFailure());
  }
};

export const removeFromCart = async (dispatch, userId, cartId, successRemove) => {
  dispatch(removeProducttoCartStart());
  try {
    const res = await userRequest.post(`${BASE_URL}cart/removeFromCart/?userId=${userId}&cartId=${cartId}`);
    console.log(res.data.data, "remove from cart ");
    dispatch(removeProducttoCartSuccess(res.data.data));
    getCartData(dispatch, userId, "runn 1");
    successRemove()
  } catch (err) {
    dispatch(removeProducttoCartFailure());
    console.log(err, 'err')
  }
};

export const emptyCart = async (dispatch, userId) => {
  try{
    const res = await userRequest.post(`${BASE_URL}cart/emptyCart/?userId=${userId}`);
    // console.log(res, 'res data for remove cart')
    getCartData(dispatch, userId);
  } catch(err){
    console.log('err at empty cart', err)
  }
}

export const getCartData = async (dispatch, userId, no) => {

  // console.log('get art data running', no)
  dispatch(getCartStart());
  try {
    const res = await userRequest.get(`${BASE_URL}cart/getCartFromUser/${userId}`);
    dispatch(getCartSuccess(res.data.data));
    // getCartData(dispatch, userId);
  } catch (err) {
    dispatch(getCartFailure());
  }
};
